export enum GroupByEnum {
    NONE = 'NONE',
    OUTLET = 'OUTLET'
}
